import React from 'react';

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
  onInfoClick?: () => void;
  className?: string;
  headerActions?: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, children, onInfoClick, className = '', headerActions }) => {
  return (
    <div
      className={`flex flex-col rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all duration-200 hover:shadow-md ${className}`}
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {onInfoClick && (
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1 h-3 w-3 cursor-pointer text-gray-400 transition-colors duration-150 hover:text-blue-500"
              onClick={onInfoClick}
            />
          )}
        </div>
        {headerActions && <div className="flex items-center gap-2">{headerActions}</div>}
      </div>
      <div className="h-full">{children}</div>
    </div>
  );
};

export default SectionCard;
